import { collectCss } from '../../../../internal/style-injector/src/index.mjs';

var css$a = ".logo_module_darkInvert__4ffe6ba9{filter:invert(var(--st-dark-mode,0))}";
collectCss(css$a);
var modules_73af8a26 = {"darkInvert":"logo_module_darkInvert__4ffe6ba9"};

export { css$a as css, modules_73af8a26 as default };
//# sourceMappingURL=logo.module.css.mjs.map
